export default __webpack_public_path__ + "static/media/error-icon.5f56b3cb.svg";